export default __webpack_public_path__ + "bfx/static/media/load.59511e5e.svg";